import { defineEvent } from '../types/event';
export var PACK_SLIDER_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'click_on_pack_slider'
        }
    ]
});
